(function () {
	'use strict';

	// class to stop elements from transitioning in on page load
	window.addEventListener('load', function () {
		document.querySelector('body').classList.remove('preload');
	});

	bravo.nav.init();
	bravo.swiper.init();
	bravo.signature.init();
	bravo.videoEmbed.init();

	const unlistedInvestmentForm = document.querySelector('#investment-form');
	if (unlistedInvestmentForm) {
		bravo.forms.unlistedInvestmentForm(unlistedInvestmentForm);
	}

	const breakpointMd = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'));
	if (window.innerWidth > breakpointMd) {
		const stickyNavTopOffset = parseInt(
			getComputedStyle(document.documentElement).getPropertyValue('--sticky-nav-top-offset')
		);
		$('body').scrollspy({ target: '#sidenav-scrollspy', offset: stickyNavTopOffset });
	}
})();